{
  "title": "Entrées et sorties",
  "subtitle": "Chaque réception, sortie, correction et stock d'ouverture, du plus récent au plus ancien.",
  "export": "Exporter vers Excel",
  "status": {
    "draft": "Brouillon",
    "pending_approval": "À approuver",
    "validated": "Validé",
    "cancelled": "Annulé",
    "reversed": "Contrepassé"
  },
  "types": {
    "stockIn": "Entrée",
    "stockOut": "Sortie",
    "adjustment": "Ajustement",
    "openingStock": "Stock d'ouverture",
    "transfer": "Transfert",
    "count": "Inventaire",
    "order": "Commande"
  },
  "subtypes": {
    "stockIn": "Réception",
    "stockOut": "Sortie",
    "adjustment": "Correction",
    "openingStock": "Démarrage"
  },
  "outTypes": {
    "sale": "Vente",
    "consumption": "Consommation",
    "internal_use": "Usage interne"
  },
  "tabs": {
    "all": "Tout",
    "stockIn": "Entrées",
    "stockOut": "Sorties",
    "adjustment": "Ajustements",
    "openingStock": "Stock d'ouverture"
  },
  "how": {
    "title": "Comment ça marche",
    "draft": "préparez librement, rien ne bouge",
    "validated": "le stock change, verrouillé pour de bon",
    "reversed": "une erreur s'annule par une nouvelle écriture"
  },
  "columns": {
    "number": "Numéro",
    "type": "Type",
    "when": "Quand · par",
    "date": "Date",
    "location": "Emplacement",
    "partner": "De / vers · référence",
    "lines": "Lignes",
    "value": "Valeur",
    "status": "Statut",
    "product": "Produit"
  },
  "list": {
    "search": "Numéro, fournisseur, client ou référence",
    "status": "Statut",
    "anyStatus": "Tous les statuts",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "lines_one": "{{count}} ligne",
    "lines_many": "{{count}} lignes",
    "lines_other": "{{count}} lignes",
    "negativeConfirmed": "Stock négatif confirmé",
    "waitingManager": "En attente d'un responsable",
    "draftDiscarded": "Brouillon abandonné",
    "emptyTitle": "Aucune opération ici pour l'instant",
    "emptyText": "Recevez du stock, sortez-en ou saisissez votre stock d'ouverture avec Nouvelle opération.",
    "showing_one": "{{count}} opération affichée",
    "showing_many": "{{count}} opérations affichées",
    "showing_other": "{{count}} opérations affichées",
    "loadMore": "Afficher plus"
  },
  "editor": {
    "new": "Nouvelle",
    "title": {
      "stockIn": "Recevoir du stock",
      "stockOut": "Sortir du stock",
      "adjustment": "Corriger le stock",
      "openingStock": "Stock d'ouverture"
    },
    "headerTitle": {
      "stockIn": "Où et de qui",
      "stockOut": "Où et pour qui",
      "adjustment": "Où et pourquoi",
      "openingStock": "Où et quand"
    },
    "linesTitle": {
      "stockIn_one": "Produits reçus · {{count}} ligne",
      "stockIn_many": "Produits reçus · {{count}} lignes",
      "stockIn_other": "Produits reçus · {{count}} lignes",
      "stockOut_one": "Produits sortis · {{count}} ligne",
      "stockOut_many": "Produits sortis · {{count}} lignes",
      "stockOut_other": "Produits sortis · {{count}} lignes",
      "adjustment_one": "Ce qui change · {{count}} ligne",
      "adjustment_many": "Ce qui change · {{count}} lignes",
      "adjustment_other": "Ce qui change · {{count}} lignes",
      "openingStock_one": "Ce que vous avez · {{count}} ligne",
      "openingStock_many": "Ce que vous avez · {{count}} lignes",
      "openingStock_other": "Ce que vous avez · {{count}} lignes"
    },
    "saving": "Enregistrement…",
    "saved": "Enregistré automatiquement à {{time}} · le stock n'a pas encore changé",
    "notSaved": "Enregistré automatiquement dès que vous ajoutez un produit",
    "sentBack": "{{name}} a renvoyé cette opération",
    "into": "Vers l'emplacement",
    "from": "Depuis l'emplacement",
    "choose": "Choisir…",
    "allLocations": "Tous les emplacements",
    "outType": "Type de sortie",
    "receivedFrom": "Reçu de",
    "issuedTo": "Remis à",
    "theirReference": "Leur référence",
    "reason": "Motif",
    "whatHappened": "Que s'est-il passé ?",
    "note": "Note",
    "scannerReady": "Scanner prêt",
    "scanPlaceholder": "Scannez un code-barres, ou tapez un nom ou une référence, puis Entrée",
    "scanAgain": "Scanner à nouveau ajoute +1",
    "noMatch": "Aucun produit ne correspond. Vérifiez le code, ou créez d'abord le produit.",
    "justScanned": "Tout juste scanné",
    "minusOne": "Un de moins",
    "plusOne": "Un de plus",
    "putIn": "Ranger dans",
    "takeFrom": "Prendre dans",
    "now": "Actuel",
    "quantity": "Quantité",
    "change": "Variation",
    "leftAfter": "Restant après",
    "unitCost": "Coût unitaire (TND)",
    "lineTotal": "Total ligne",
    "add": "+ Ajouter",
    "remove": "− Retirer",
    "sameAsAbove": "Comme ci-dessus",
    "costFromProduct": "Prix de revient de référence",
    "firstReceipt": "Première réception : le coût moyen démarre à {{cost}}",
    "averageWillGo": "Le coût moyen passera de {{from}} à {{to}}",
    "removeLine": "Retirer la ligne",
    "noLines": "Aucun produit pour l'instant : scannez un code-barres ou tapez un nom ci-dessus.",
    "summary": "Résumé",
    "totalValue": "Valeur totale",
    "explain": {
      "stockIn": "À la validation, le stock augmente dans cet emplacement, le coût moyen de chaque produit est mis à jour et la réception est verrouillée.",
      "stockOut": "À la validation, le stock diminue au coût moyen actuel et la sortie est verrouillée. Passer sous zéro demande une confirmation.",
      "adjustment": "À la validation, le stock est corrigé au coût moyen actuel. Une grosse correction attend un responsable.",
      "openingStock": "À la validation, ces quantités et ces coûts deviennent le stock de départ de chaque produit."
    },
    "validate": {
      "stockIn": "Valider la réception",
      "stockOut": "Valider la sortie",
      "adjustment": "Valider la correction",
      "openingStock": "Valider le stock d'ouverture"
    },
    "validated": {
      "stockIn": "Réception {{number}} validée",
      "stockOut": "Sortie {{number}} validée",
      "adjustment": "Correction {{number}} validée",
      "openingStock": "Stock d'ouverture {{number}} validé"
    },
    "sentForApproval": "Envoyé à un responsable : au-dessus du seuil de validation",
    "fixIssues": "Il manque des informations : voir les champs en rouge",
    "cannotValidate": "Votre rôle prépare des brouillons ; une personne autorisée à valider les terminera.",
    "keepDraft": "Garder en brouillon",
    "discard": "Abandonner le brouillon",
    "discardTitle": "Abandonner ce brouillon ?",
    "discardText": "Rien n'a bougé. Le brouillon garde son numéro et apparaît comme Annulé.",
    "discarded": "Brouillon abandonné",
    "shortcut": "Raccourci : Ctrl + Entrée pour valider",
    "customizationNone": "Non choisi",
    "amountDue": "Montant à payer au fournisseur",
    "amountDueHint": "Le total de sa facture quand il diffère de la valeur des marchandises (TVA, transport, timbre)."
  },
  "negative": {
    "title_one": "{{count}} produit va passer sous zéro",
    "title_many": "{{count}} produits vont passer sous zéro",
    "title_other": "{{count}} produits vont passer sous zéro",
    "text": "Vous sortez plus que ce que le système indique à {{places}}. Vous pouvez continuer, mais ce sera enregistré à votre nom et affiché en stock négatif jusqu'à correction.",
    "askManager": "Vous sortez plus que ce que le système indique. Seules les personnes autorisées à confirmer un stock négatif peuvent continuer : demandez à un responsable.",
    "blocked": "Le stock négatif est bloqué dans la configuration. Recevez d'abord la quantité manquante ou corrigez le stock.",
    "productLocation": "Produit · emplacement",
    "now": "Actuel",
    "change": "Sortie",
    "after": "Après",
    "checkbox": "J'ai vérifié : ces articles sont bien sortis. La quantité manquante sera corrigée plus tard par un inventaire ou une réception.",
    "goBack": "Revenir et modifier",
    "confirm": "Confirmer et valider",
    "footnote": "Seules les personnes autorisées à confirmer un stock négatif voient ce bouton. Les autres doivent appeler un responsable."
  },
  "detail": {
    "locked": "Verrouillé · validé {{when}} par {{name}}",
    "lockedHint": "Une opération validée ne change plus jamais. En cas d'erreur, contrepassez-la : une nouvelle écriture l'annule et les deux restent dans l'historique.",
    "export": "Exporter vers Excel",
    "reverse": "Contrepasser…",
    "reversedBy": "Contrepassé {{when}} par {{name}}",
    "negativeConfirmed": "Stock négatif confirmé par {{name}}",
    "createdBy": "Créé par",
    "movements": "Mouvements de stock écrits",
    "transaction": "Transaction {{number}} · ne peut jamais être modifiée",
    "balanceAfter": "Solde après",
    "reversal": "Contrepassation",
    "lines": "Lignes",
    "nothingMoved": "Rien n'a encore bougé.",
    "history": "Historique de ce document",
    "failed": "refusé",
    "source": {
      "transfer": "Perte en transit du transfert {{number}}",
      "count": "Correction de l'inventaire {{number}}"
    },
    "openSource": "Ouvrir {{number}}",
    "sourceHint": "Créé par son inventaire ou son transfert, en même temps. Il ne se contrepasse pas seul."
  },
  "reversal": {
    "title": {
      "stockIn": "Contrepasser cette réception ?",
      "stockOut": "Contrepasser cette sortie ?",
      "adjustment": "Contrepasser cette correction ?",
      "openingStock": "Contrepasser ce stock d'ouverture ?"
    },
    "text": "Rien n'est supprimé. Une nouvelle écriture annule ces quantités, à leur coût d'origine, et les deux écritures restent dans l'historique.",
    "why": "Pourquoi ?",
    "note": "Précisions (facultatif)",
    "reasons": {
      "entered_twice": "Saisi deux fois par erreur",
      "wrong_quantity": "Mauvaise quantité",
      "wrong_product": "Mauvais produit",
      "wrong_location": "Mauvais emplacement, ressaisi",
      "wrong_cost": "Mauvais coût",
      "other": "Autre raison"
    },
    "keep": "La garder",
    "confirm": "Contrepasser {{number}}",
    "done": "{{number}} contrepassé"
  },
  "approval": {
    "needs": "{{name}} a besoin de l'accord d'un responsable.",
    "worth": "Valeur : {{value}} TND, au-dessus du seuil de {{limit}} TND fixé dans la configuration. Rien n'a encore changé dans le stock.",
    "nothingYet": "Ce montant dépasse le seuil fixé dans la configuration. Rien n'a encore changé dans le stock.",
    "decision": "Votre décision",
    "comment": "Commentaire",
    "commentHint": "Visible par {{name}} et gardé dans le journal",
    "approve": "Approuver et valider",
    "sendBack": "Renvoyer à {{name}}",
    "commentNeeded": "Écrivez un commentaire pour la renvoyer.",
    "approved": "Approuvé et validé",
    "sentBack": "Renvoyé à {{name}}",
    "waiting": "En attente d'un responsable",
    "waitingText": "Un responsable l'approuve avant que le stock ne change."
  }
}
